import { OptionList } from "../../assets/helpers/helpers";

// Backend (GET /api/User/permissions) returns a label map:
// { "License.Edit": "Edit Licenses", "Product.Delete": "Delete Products", ... }.
// Build the multiselect options straight from it — `data` is the permission key
// sent to the API, `name` is the human-readable label shown in the UI.
export const buildPermissionOptions = (
    labels: Record<string, string>
): OptionList =>
    Object.entries(labels).map(([key, label], index) => ({
        id: index,
        name: label,
        data: key,
    }));

export const permissionIdsToKeys = (
    options: OptionList,
    ids: number[]
): string[] =>
    options.filter((option) => ids.includes(option.id)).map((option) => option.data as string);

export const permissionKeysToIds = (
    options: OptionList,
    keys: string[]
): number[] =>
    options.filter((option) => keys.includes(option.data as string)).map((option) => option.id);
